import Table from "src/components/Common/UI/DndTable/Table";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useSubordinateUnitsTable } from "./hooks/useSubordinateUnitsTable";

const SubordinateUnitsTable = ({unitID}: SubordinateUnitsTableProps) => {

  const {
    columns,
    data,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
  } = useSubordinateUnitsTable({unitID: unitID});

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={false} canDelete={false} showDetails={selectedRowsOfTable.length > 0} />
  );

  if(!loadingDone) {
    return<LoadingSpinner /> 
  }

  return (
    <Table
      columns={columns}
      data={data}
      defaultOrderByKeyFilter={"id"}
      showNumberOfRows={false}
      rowSelection={true}
      setRowSelection={setSelectedRowsOfTable}
      multipleRowSelection={false}
      actionRowId={"id"}
      debugMode={false}
      noDataFoundTitle="No Establishments yet"
      isChangeOrderOrVisibilityEnable={false}
      ButtonsAreaLeft={ActionButtons}
      hiddenColumnsForUser={["deleted"]}
      textPosition="center"
      maxHeight="33rem"
    />
  )
}

export default SubordinateUnitsTable;

interface SubordinateUnitsTableProps {
  unitID: number;
}